import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";

import Lottie from "react-lottie-player";


import arrowAnimation from '../../../animations/crm/moving_arrows.json';

import Stage1Image from '../../../assets/crm/lead-contacted.jpg';
import Stage2Image from '../../../assets/crm/lead-qualified.jpg';
import Stage3Image from '../../../assets/crm/lead-closed.jpg'


import LeadManagementImage from '../../../assets/hrm/LeaveCalendar.jpg';

import DealManagementImage from '../../../animations/hrm/attendance.json';

import FinancialMetricsImage from '../../../assets/hrm/FinancialMetrics.jpg';
import TopPerformersImage from '../../../assets/hrm/TopPerformers.jpg';

import InvoiceManagementImage from '../../../assets/crm/sales-invoice.jpg';
import CustomerManagementImage from '../../../assets/crm/customers.jpg';

import SearchedItem from '../../../assets/crm/item.jpg';
import SearchedItemDetails from '../../../assets/crm/item-specs.jpg';

const KanbanStage = ({ stage, active }) => (
  <div
    className={`relative transition-transform duration-500 ease-in-out opacity-50 scale-90 border rounded-lg p-4 mx-2 bg-gray-700 shadow-lg text-white ${
      active
        ? "opacity-100 scale-110 border-cyan-400 shadow-xl bg-cyan-900" // Increase scale when active
        : "border-gray-500"
    }`}
    style={{ width: "300px" }}
  >
    <h3 className="text-md font-bold mb-2">{stage.title}</h3>
    <p className="text-sm text-gray-300 mt-2 mb-2">{stage.description}</p>
    <img
      src={stage.img}
      alt={stage.title}
      className="rounded-lg shadow-lg w-full h-auto"
    />
    
  </div>
);


const LottieArrow = ({ play }) => (
  <div className="relative flex justify-center items-center h-36 w-40 mx-0">
    <Lottie
      animationData={arrowAnimation}
      loop={true}
      play={play}
      className="h-full w-full"
    />
  </div>
);

const KanbanWorkflow = () => {
  const stages = [
    {
      title: "Stage 1: Leads",
      img: Stage1Image, // Replace with your image path
      description: "Manage incoming leads and track their progress."
    },
    {
      title: "Stage 2: Opportunities",
      img: Stage2Image, // Replace with your image path
      description: "Work on converting leads into opportunities."
    },
    {
      title: "Stage 3: Closed Deals",
      img: Stage3Image, // Replace with your image path
      description: "Successfully close deals and onboard customers."
    }
  ];

  const [activeStage, setActiveStage] = useState(0);
  const [playArrow, setPlayArrow] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlayArrow(true); // Start playing arrow animation

      setTimeout(() => {
        setPlayArrow(false); // Stop playing arrow animation
        setActiveStage((prevStage) => (prevStage + 1) % stages.length); // Move to next stage
      }, 2000); // Duration of the arrow animation

    }, 3000); // Total duration for each stage + arrow animation

    return () => clearInterval(interval);
  }, [stages.length]);

  return (
    <div className="w-full flex items-center justify-center px-4 py-8">
      {stages.map((stage, index) => (
        <React.Fragment key={index}>
          <KanbanStage stage={stage} active={index === activeStage} />
          {index < stages.length - 1 && (
            <LottieArrow play={index === activeStage && playArrow} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};


function CRMManagement() {

  const [activeStage, setActiveStage] = useState(0);

  const stages = [
    { id: 1, title: "Stage 1: Leads", img: Stage1Image },
    { id: 2, title: "Stage 2: Opportunities", img: Stage2Image },
    { id: 3, title: "Stage 3: Closed Deals", img: Stage3Image },
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative bg-[#0A0F1F] text-white py-10 mt-28 overflow-hidden">
        <div className="container mx-auto px-6 py-10 lg:flex lg:items-center lg:justify-between">
          {/* Left Section */}
          <div className="lg:w-1/1 text-center lg:text-left">
            <h1 className="font-larger mb-10">SALES & CUSTOMER RELATIONSHIP MANAGEMENT</h1>
            <p className="mt-6 text-gray-300 max-w-md">
              <b>Streamline your sales process and customer relationship management with our comprehensive module.
              </b>
            </p>
            <div className="mt-8 flex justify-center lg:justify-start gap-4">
              <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-semibold rounded-md shadow-md hover:bg-yellow-300 transition">
                Get Started
              </button>
            </div>
          </div>

          {/* Right Section */}
          <div className="lg:w-2/3 relative">
          </div>
        </div>
      </section>


      {/* Customer Management Portal */}
      <section className="border border-dashed border-blue-900 py-16 mx-2 text-white bg">
          <div className="container mx-auto mb-12 text-center">
              <h1 className="text-4xl font-bold text-blue-400">Customer Management</h1>
              <p className="mt-4 text-lg text-gray-400">
                  Manage your customer data from one centralized platform.
              </p>
          </div>

          <div className="container mx-auto grid grid-cols-1 md:grid-cols-[40%_60%] items-center justify-center">

              {/* Generalized Customer Management */}
              <div className="p-4 rounded-lg shadow-md flex items-center justify-center">
                  <div>
                      <h2 className="text-2xl font-semibold text-blue-400">Seamless Customer Operations</h2>
                      <p className="mt-4 text-gray-300">
                          Effortlessly manage your customers—all from a unified dashboard designed for efficiency and clarity.
                      </p>
                      <ul className="mt-4 text-sm text-gray-400 list-disc list-inside">
                          <li>Add, Edit, Delete, Activate/Deactivate Customers</li>
                          <li>Search Functionality: Quickly find specific customers</li>
                          <li>Full customer information view and status control</li>
                      </ul>
                  </div>
              </div>

              {/* Customer Management Illustration */}
              <div className="relative p-2 mt-10 rounded-lg shadow-md flex justify-center items-center">
                  <img 
                      src={CustomerManagementImage} 
                      alt="Customer Management Illustration" 
                      className="w-full h-auto rounded-lg shadow-lg transform transition duration-500 hover:scale-100 hover:rotate-2 z-10"
                  />
              </div>
          </div>
      </section>


      {/* Sales Pipeline Management */}
{/* Sales Pipeline Management */}
<section className="border border-dashed border-blue-900 py-8 mt-20 mx-2 text-white bg">
    <div className="container mx-auto mb-12 text-center">
        <h1 className="text-4xl font-bold text-blue-400">Sales Pipeline Management</h1>
        <p className="mt-4 text-lg text-gray-400">
            Streamline your sales operations with a robust pipeline that handles leads and deals efficiently, ensuring a smooth transition from prospecting to closing.
        </p>
    </div>

    <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center">

        {/* Lead Management */}
        <div className="text-left p-8 rounded-lg shadow-md flex items-center justify-center">
            <div>
                <h2 className="text-2xl font-semibold text-blue-400">Leads</h2>
                <p className="mt-4 text-gray-300">
                    Effectively manage incoming leads with detailed tracking, scoring, and seamless assignment workflows to ensure no opportunity is missed.
                </p>
                <ul className="mt-4 text-sm text-gray-400 list-disc list-inside">
                    <li>Add, edit, delete, and search leads</li>
                    <li>Assign leads to specific employees</li>
                    <li>Score leads based on predefined criteria</li>
                    <li>Track lead history and engagement</li>
                </ul>
            </div>
        </div>

        {/* Deal Management */}
        <div className="text-left p-8 rounded-lg shadow-md flex items-center justify-center">
            <div>
                <h2 className="text-2xl font-semibold text-blue-400">Deals</h2>
                <p className="mt-4 text-gray-300">
                    Convert successful leads into deals, manage deal progress, and centralize critical information for efficient decision-making.
                </p>
                <ul className="mt-4 text-sm text-gray-400 list-disc list-inside">
                    <li>Create, edit, and track deals</li>
                    <li>Add attachments and quotations</li>
                    <li>Convert closed deals into customers</li>
                    <li>Monitor deal progress and milestones</li>
                </ul>
            </div>
        </div>

        {/* Kanban View Emphasis */}
        <div className="col-span-1 md:col-span-2 py-8 mt-10 rounded-lg shadow-md bg-gray-800 flex flex-col items-center justify-center">
            <div className="container mx-auto text-center">
                <h1 className="text-4xl font-bold text-blue-400">Kanban View</h1>
                <p className="mt-4 text-lg text-gray-400">
                    Visualize your sales workflow with an interactive Kanban board. Drag and drop leads and deals between stages.
                </p>
            </div>

            <KanbanWorkflow />
        </div>

    </div>
</section>



    {/* Invoice Management Section */}
<section className="border border-dashed border-blue-900 py-16 mt-20 mx-2 text-white bg">
    <div className="container mx-auto mb-12 text-center">
        <h1 className="text-4xl font-bold text-blue-400">Invoice Management</h1>
        <p className="mt-4 text-lg text-gray-400">
            Streamline your billing process with comprehensive invoice management, supporting both sales and quotation invoices, integrated with your product catalog and customers.
        </p>
    </div>

    <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">

        {/* Quotation Management */}
        <div className="text-left p-8 mt-10 rounded-lg shadow-md flex items-center justify-center">
            <div>
                <h2 className="text-2xl font-semibold text-blue-400">Quotation & Sales Invoices</h2>
                <p className="mt-4 text-gray-300">
                    Manage invoices efficiently, allowing for easy conversion to invoices once approved, and ensuring smooth integration with the sales process.
                </p>
                <ul className="mt-4 text-sm text-gray-400 list-disc list-inside">
                    <li>Add, edit, delete, and search invoices seamlessly</li>
                    <li>Approve quotations and sales for stock management</li>
                    <li>Attach quotations to sales for automatic data fetching</li>
                    <li>Get printable invoices with your company details</li>
                    <li>Track sales history and status</li>
                </ul>
            </div>
        </div>

        {/* Invoice Management Illustration */}
        <div className="relative p-8 mt-10 rounded-lg shadow-md flex justify-center items-center">
            <img 
                src={InvoiceManagementImage} 
                alt="Invoice Management Illustration" 
                className="rounded-lg shadow-lg transform transition duration-500 hover:scale-125 hover:rotate-2 z-10"
                
            />
        </div>

        
        {/* Product Catalog */}
        <div className="relative p-8 mx-4 rounded-lg shadow-md flex justify-center items-center">
            {/* First Image */}
            <img 
                src={SearchedItem} 
                alt="Searched Item" 
                className="w-[65%] h-auto rounded-lg shadow-lg transform transition duration-500 hover:scale-105 hover:rotate-0 z-0"
            />
            {/* Second Image */}
            <img 
                src={SearchedItemDetails} 
                alt="Searched Item Details" 
                className="w-[60%] h-auto rounded-lg shadow-lg transform -rotate-12 -translate-x-8 translate-y-8 transition duration-500 hover:scale-105 hover:rotate-0 z-10"
            />
        </div>

        {/* Product Catalog Management */}
        <div className="text-left p-8 mt-10 rounded-lg shadow-md flex items-center justify-center">
            <div>
                <h2 className="text-2xl font-semibold text-blue-400">Product Catalog</h2>
                <p className="mt-4 text-gray-300">
                    Maintain a detailed product catalog for your invoices, including products and services, to ensure accurate billing and inventory management.
                </p>
                <ul className="mt-4 text-sm text-gray-400 list-disc list-inside">
                    <li>Add, edit, delete, and search products</li>
                    <li>Link products and services to invoices and quotations</li>
                    <li>Manage pricing, stock levels, and product details</li>
                </ul>
            </div>
        </div>

        
    </div>
</section>



    </Layout>
  );
}

export default CRMManagement;
